<template>
  <div id="app">
    <router-view></router-view>
    <div id="sy" style="position: fixed; width: 120%; height: 110%; top: 0px; left: 0px; pointer-events: none; z-index: 9999;">
      <pre v-for="(item,index) in 100" :id="'mask_'+item" :key="index" class="mask_div">{{masktxt}}</pre>
    </div>
  </div>
</template>
<script>
export default{
  data(){return{masktxt:''}},
//绑定监听事件
mounted() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))//监听页面刷新事件
    var now = this.getNow();
          this.masktxt=localStorage.getItem('user1')+"@ntlawyer.cc"+"\n"+ now;
          setInterval(this.updatemask,1000);
},
methods: {
    beforeunloadHandler(e) {
      sessionStorage.removeItem('hasRoles')
    },
    getNow() {
            var d = new Date();
            var year = d.getFullYear();
            var month = change(d.getMonth() + 1);
            var day = change(d.getDate());
            var hour = change(d.getHours());
            var minute = change(d.getMinutes());
            var second = change(d.getSeconds());

            function change(t) {
                if (t < 10) {
                    return "0" + t;
                } else {
                    return t;
                }
            }
            var time = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second + '';
            return time;
        },
    updatemask(){
          if(document.getElementsByClassName('mask_div').length!=100){
            this.$destroy();
            window.location.href='/'
          }
          var now = this.getNow();
          this.masktxt=localStorage.getItem('user1')+"@ntlawyer.cc"+"\n"+ now;
        }
},
created() {
    //this.watermark();
    
  },
//页面销毁前解除监听
destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
}
}
</script>
<style lang="less" scoped>
#app {
  height: 100%;
  width: 99.9%;
  //针对火狐浏览器
scrollbar-color: rgba(144, 147, 153, 0.4) transparent; /* 滑块颜色  滚动条背景颜色 */
scrollbar-width: thin; /* 滚动条宽度有三种：thin、auto、none */
::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.4);
  border-radius: .625rem;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar {
  /* 对应纵向滚动条的宽度 */
  width: .625rem;
  /* 对应横向滚动条的宽度 */
  height: .725rem;
  // background-color: #2bc887;
}

}
html, body {
    height: 100%;
    width: 99%;
}

.mask_div{
  transform: rotate(-40deg); 
  position: relative; 
  overflow: hidden; 
  z-index: 9999; 
  pointer-events: none; 
  opacity: 0.1; 
  font-size: 1rem; 
  font-family: 微软雅黑; 
  color: rgb(170, 170, 170); 
  text-align: left; 
  width: 12%; 
  display: block;
  float: left;
  margin-left: -2%;
  margin-bottom: 5%;
}
</style>